import React, { Children } from 'react';
import { Container } from './ui/Container';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
interface ClassTileProps {
  title: string;
  image: string;
  link: string;
  benefit: string;
}
function ClassTile({
  title,
  image,
  link,
  benefit
}: ClassTileProps) {
  return <div className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 flex flex-col h-full" data-id="element-1">
      <a href={link} className="relative block aspect-[4/3] overflow-hidden" data-id="element-2">
        <img src={image} alt={title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" data-id="element-3" />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300" data-id="element-4"></div>
      </a>

      <div className="p-6 flex flex-col flex-grow" data-id="element-5">
        <h3 className="text-xl font-bold text-nav mb-2 font-heading uppercase tracking-wide" data-id="element-6">
          {title}
        </h3>
        <p className="text-gray-600 text-sm mb-6 flex-grow" data-id="element-7">{benefit}</p>

        <a href={link} className="mt-auto" data-id="element-8">
          <Button variant="outline" fullWidth className="group-hover:bg-accent group-hover:border-accent group-hover:text-white" data-id="element-9">
            Learn More
          </Button>
        </a>
      </div>
    </div>;
}
export function ClassesSection() {
  const classes = [{
    title: "Children's Classes",
    link: 'https://dragonmartialarts-rl.com/children-classes/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/1-1-o2ie1565wtxl22u9dvvjlpnumcrxi0h9tj38i3ji36.jpg',
    benefit: 'Build focus, discipline, and confidence in a fun environment.'
  }, {
    title: 'Children / Adult Classes',
    link: 'https://dragonmartialarts-rl.com/child-adults-classes/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/2-1-o2ie1n13iom16o4bhllgf35lwobwk9g67zhgmct0sy.jpg',
    benefit: 'Family-friendly training for parents and kids together.'
  }, {
    title: 'Cardio Kickboxing',
    link: 'https://dragonmartialarts-rl.com/cardio-kickboxing/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/3-1-o2ie11et5hsfrmzpzu91bqm08tagn82ch0hakzp2s2.jpg',
    benefit: 'High-energy workout to improve fitness and stamina.'
  }, {
    title: 'FIT KIDS Program',
    link: 'https://dragonmartialarts-rl.com/fit-kids-program/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/4-1-o2ie0xnge5nah756lsmj1rk5v9szsfnf4hvcnvungy.jpg',
    benefit: 'Active program designed to keep kids moving and healthy.'
  }, {
    title: 'Advanced Classes',
    link: 'https://dragonmartialarts-rl.com/advanced/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/advanced-class-o2ie18xio62qciosrxi1vopozw9ecsw761p6f7dxea.jpg',
    benefit: 'Take your skills to the next level with advanced techniques.'
  }, {
    title: 'Sparring',
    link: 'https://dragonmartialarts-rl.com/sparring/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/Left-o2ie1ibwkiflkmb591kbkmcaxqz2hrxijc817yzzo2.jpg',
    benefit: 'Apply techniques in controlled, competitive scenarios.'
  }, {
    title: 'Demo Team',
    link: 'https://dragonmartialarts-rl.com/demo-team/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/7-o2ie1owrwcoltw1l6mepk2oj3g2mznnmw8sfkwq8gi.jpg',
    benefit: 'Showcase skills at community events and demonstrations.'
  }, {
    title: 'Community Engagement',
    link: 'https://dragonmartialarts-rl.com/community-events/',
    image: 'https://dragonmartialarts-rl.com/wp-content/uploads/elementor/thumbs/community-o2ie1br18o6lbckpbgpxl602s1vhzw7e6fnmv19qvm.jpg',
    benefit: 'Connect with the local community through martial arts.'
  }];
  return <section id="classes" className="py-20 bg-gray-50" data-id="element-10">
      <Container data-id="element-11">
        <div className="text-center mb-16" data-id="element-12">
          <h2 className="text-3xl md:text-4xl font-extrabold text-nav mb-4 uppercase tracking-tight font-heading" data-id="element-13">
            Our Programs
          </h2>
          <div className="w-20 h-1 bg-accent mx-auto mb-6" data-id="element-14"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-15">
            Something for everyone — all ages and skill levels welcome
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-16">
          {classes.map((item, index) => <ClassTile key={index} {...item} data-id="element-17" />)}
        </div>

        {/* CTA Bar */}
        <div className="bg-nav rounded-lg p-8 md:p-12 text-center shadow-xl" data-id="element-18">
          <h3 className="text-2xl font-bold text-white mb-6 font-heading" data-id="element-19">
            Not sure where to start?
          </h3>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-20">
            <a href="#signup" className="w-full sm:w-auto" data-id="element-21">
              <Button variant="primary" size="lg" fullWidth data-id="element-22">
                Get One Week Free Trial
              </Button>
            </a>
            <a href="tel:8472128045" className="w-full sm:w-auto" data-id="element-23">
              <Button variant="secondary" size="lg" fullWidth data-id="element-24">
                Call (847) 212-8045
              </Button>
            </a>
          </div>
        </div>
      </Container>
    </section>;
}